import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import "./Refunds.css";

const Refund = () => {
  return (
    <div>
      <SEO
        title="Exchange & Delivery Policy"
        description="The Brik's delivery timelines, shipping costs, and exchange policy: processing times, USPS shipping, and how exchanges work."
        path="/exchange-and-delivery"
      />
      <Header />
      <div className="refund-container">
        <h1>Exchange and Delivery Policy</h1>
        <p>Last Updated: February 22, 2025</p>

        <h2>1. Overview</h2>
        <p>
          Thank you for shopping at The Brik. We are committed to ensuring that your orders are delivered on time and that you are completely satisfied with your purchase. This policy outlines our procedures for delivery and exchanges. Please note that we do not offer refunds.
        </p>

        <h2>2. Delivery Policy</h2>
        <ul>
          <li>
            <strong>Order Processing:</strong> Orders are typically processed within 1 business day. During periods of high order volume, processing may take 2-3 business days.
          </li>
          <li>
            <strong>Shipping Partner:</strong> We use Pirate Ship in partnership with USPS to ship your order.
          </li>
          <li>
            <strong>Shipping Time:</strong> Standard delivery typically takes 3-4 days, with a maximum of 7-9 days depending on USPS.
          </li>
          <li>
            <strong>Tracking:</strong> Once your order is shipped, tracking information will be provided via email.
          </li>
          <li>
            <strong>Shipping Charges:</strong> Shipping is free on every order, with no minimum.
          </li>
        </ul>

        <h2>3. Exchanges</h2>
        <ul>
          <li>
            <strong>Eligibility:</strong> We offer exchanges only if the product is destroyed. If your item arrives destroyed or becomes completely unusable due to a defect or damage during shipping, please contact us immediately.
          </li>
          <li>
            <strong>Proof of Destruction:</strong> To process an exchange, you must provide clear photos and a detailed description verifying that the product is destroyed.
          </li>
          <li>
            <strong>Exchange Process:</strong> Once your claim is verified, we will provide instructions on how to proceed with the exchange.
          </li>
        </ul>

        <h2>4. Exchange Shipping</h2>
        <p>
          In the event of an approved exchange, you may be required to ship the destroyed item to us. Shipping costs for returning the destroyed item will be covered by us once the exchange is confirmed.
        </p>

        <h2>5. How to Initiate an Exchange or Delivery Inquiry</h2>
        <p>
          To request an exchange or inquire about delivery issues, please contact our support team at{" "}
          <a href="mailto:asray@the-brik.com">asray@the-brik.com</a>. Provide your order number and details regarding your inquiry, and our customer service team will guide you through the next steps.
        </p>

        <h2>6. Contact Us</h2>
        <p>
          If you have any questions about our Exchange and Delivery Policy, please reach out:
        </p>
        <address>
          <strong>The Brik LLC</strong>
          <br />
          119 Stanton Avenue
          <br />
          Ames, IA 50014
          <br />
          Email: <a href="mailto:asray@the-brik.com">asray@the-brik.com</a>
          <br />
          Phone: +1 (714) 787-9947
        </address>
      </div>
      <Footer />
    </div>
  );
};

export default Refund;
